import { render, staticRenderFns } from "./ArticleListForm.vue?vue&type=template&id=cb740636&scoped=true"
import script from "./ArticleListForm.vue?vue&type=script&lang=js"
export * from "./ArticleListForm.vue?vue&type=script&lang=js"
import style0 from "./ArticleListForm.vue?vue&type=style&index=0&id=cb740636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb740636",
  null
  
)

export default component.exports